import { render, staticRenderFns } from "./untaken_orders.vue?vue&type=template&id=57f2c61c&"
import script from "./untaken_orders.vue?vue&type=script&lang=js&"
export * from "./untaken_orders.vue?vue&type=script&lang=js&"
import style0 from "./untaken_orders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports